import { gql } from "@apollo/client";

export const GET_USER_FOR_SELECT = gql`
  query SelectUser($role: [String]) {
    selectUser(role: $role) {
      _id
      profile
      firstNameKh
      lastNameKh
      gender
      role
    }
}
`;

export const GET_MEMBER_FOR_SELECT = gql`
  query GetMemberForSelect {
    getMemberForSelect {
      _id
      latinName
      lastNameKh
      firstNameKh
    }
  }
`;

export const GET_CANDIDATE_IN_MANDATE_FOR_SELECT = gql`
  query GetCandidateInMandateForSelect {
    getCandidateInMandateForSelect {
      _id
      firstNameKh
      lastNameKh
      latinName
      candidateId
      numberOrder
      party {
        _id
        partyName
        logo
        remark
        isDefault
      }
    }
  }
`;

export const GET_CANDIDATE_FOR_SELECT = gql`
  query GetCandidateForSelect {
    getCandidateForSelect {
      firstNameKh
      lastNameKh
      latinName
      _id
    }
  }
`;

export const GET_MANDATE_FOR_COPY_CADIDATE = gql`
  query GetMandateForCopyCadidate {
    getMandateForCopyCadidate {
      _id
      mandateName
      startDate
      endDate
      isActive
      remark
      totalMember
      totalParty
    }
  }
`;

export const GET_PARTY_FOR_COPY_CADIDATE = gql`
  query GetPartyForCopyCandidate($mandateId: ID!) {
    getPartyForCopyCandidate(mandateId: $mandateId) {
      _id
      partyName
      logo
      remark
      isDefault
    }
  }
`;

export const GET_INSTITUTE_OR_UNIVERSITY_FOR_SELECT = gql`
  query GetInstituteOrUniversityForSelect {
    getInstituteOrUniversityForSelect {
      _id
      nameKh
      nameEng
    }
  }
`;

export const GET_COUNCIL_POSITION_FOR_SELECT = gql`
  query GetCouncilPositionsForSelect {
    getCouncilPositionsForSelect {
      _id
      positionsNameKh
      positionsNameEng
      isDefault
    }
  }
`;

export const GET_PARTY_FOR_SELECT = gql`
  query GetPartyForSelect {
    getPartyForSelect {
      _id
      partyName
      logo
      remark
    }
  }
`;

export const GET_PARTY_BY_MANDATE = gql`
  query GetPartyByMandate {
    getPartyByMandate {
      _id
      partyName
      isDefault
      logo
      remark
    }
  }
`;

export const GET_MAJORS_FOR_SELECT = gql`
  query GetMajorsForSelect {
    getMajorsForSelect {
      _id
      majorsNameKh
      majorsNameEng
    }
  }
`;

export const GET_CAPITAL_PROVINCE = gql`
  query GetCapitalProvince {
    getCapitalProvince {
      _id
      isDefault
      capital_province_name_kh
      capital_province_name_en
    }
  }
`;

export const GET_DISTRICT_BY_PROVINCE = gql`
  query GetDistrictByProvice($capicalProvincesId: ID!) {
    getDistrictByProvice(capical_provinces_id: $capicalProvincesId) {
      _id
      isDefault
      district_municipality_name_kh
      district_municipality_name_en
      district_municipality_code
      district_municipality_type
    }
  }
`;

export const GET_COMMUNE_BY_DISTRICT = gql`
  query GetCommuneByDistrict($districtMunicipalitiesId: ID!) {
    getCommuneByDistrict(
      district_municipalities_id: $districtMunicipalitiesId
    ) {
      _id
      commune_sangkat_name_en
      commune_sangkat_name_kh
      commune_sangkat_code
      commune_sangkat_type
    }
  }
`;

export const GET_VILLAGE_BY_COMMUNE = gql`
  query GetVillageByCommune($communeSangkatId: ID!) {
    getVillageByCommune(commune_sangkat_id: $communeSangkatId) {
      _id
      village_name_en
      village_name_kh
      village_code
    }
  }
`;

export const GET_REASON_OF_LOSS_MEMBER_FOR_SELECT = gql`
  query GetReasonOfLossMemberForSelect {
    getReasonOfLossMemberForSelect {
      _id
      reason_title
      isDefault
    }
  }
`;

export const GET_PROVINCAIL_COUNCIL_IN_MANDATE_FOR_SELECT = gql`
query GetProvincailCouncilInMandateForSelect {
  getProvincailCouncilInMandateForSelect {
    provincialCouncilInMandateId
    firstNameKh
    lastNameKh
    latinName
  }
}
`;

export const  GET_SECRETARY_IN_MANDATE_FOR_SELECT = gql`
query GetSecretaryInMandateForSelect {
  getSecretaryInMandateForSelect {
    secretaryInMandateId
    firstNameKh
    lastNameKh
    latinName
  }
}
`;

export const GET_WORK_GROUP_FOR_SELECT = gql`
query GetWorkGroupForSelect {
  getWorkGroupForSelect {
    _id
    numbering
    work_group_name
  }
}
`;
